interface ServiceCardProps {
  title: string;
  description: string;
  link: string;
  imageUrl: string;
  imageAlt: string;
}

export default function ServiceCard({ title, description, link, imageUrl, imageAlt }: ServiceCardProps) {
  return (
    <div className="group bg-white rounded-xl overflow-hidden transition-all duration-300 hover:translate-y-[-2px] cursor-pointer">
      <div className="relative w-full h-48 overflow-hidden">
        <img
          src={imageUrl}
          alt={imageAlt}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="p-5">
        <h3 className="font-heading font-bold text-lg text-foreground-950 mb-2">
          {title}
        </h3>
        <p className="text-foreground-600 text-sm leading-relaxed mb-4">
          {description}
        </p>
        <Link
          to={link}
          className="inline-flex items-center gap-2 text-secondary-500 font-semibold text-sm hover:text-secondary-600 transition-colors cursor-pointer"
        >
          Voir le traitement
          <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
        </Link>
      </div>
    </div>
  );
}